/**
 * Convert string to snake case
 * @param {String} str - string to be converted
 * @returns {String}
 */
const toSnakeCase = (str) => {
  if (!str) return '';
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

/**
 * Recursivly convert object to snake case
 * @param {Object} obj - object to be converted
 * @returns {Object}
 */
const snakeCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => snakeCase(item)); // Recursively handle array elements
  }

  if (typeof obj === 'object' && obj !== null) {
    const newObj = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const snakeCaseKey = toSnakeCase(key);
        newObj[snakeCaseKey] = snakeCase(obj[key]); // Recursively handle nested objects
      }
    }
    return newObj;
  }
  return obj;
};

/**
 * Convert string to camel case
 * @param {String} str - string to be converted
 * @returns {String}
 */
const toCamelCase = (str) => {
  return str.replace(/([-_][a-z])/g, (letter) =>
    letter.toUpperCase().replace('-', '').replace('_', ''),
  );
};

/**
 * Recursivly convert object to camel case
 * @param {Object} obj - object to be converted
 * @returns {Object}
 */
const camelCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => camelCase(item)); // Recursively handle array elements
  }

  if (typeof obj === 'object' && obj !== null) {
    const newObj = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const camelKey = toCamelCase(key);
        newObj[camelKey] = camelCase(obj[key]); // Recursively handle nested objects
      }
    }
    return newObj;
  }
  return obj;
};

export { snakeCase, camelCase };
